
import gui  from '@/webgl/dev/gui'

import Post from 'nanogl-post'


// import Chromashift  from '@/webgl/glsl/post/chromashift'
// import Fetch from 'nanogl-post/effects/fetch'
// import Contrast from 'nanogl-post/effects/contrast'
// import Grain from 'nanogl-post/effects/grain'
// import LUT from 'nanogl-post/effects/lut'
// import Saturation from 'nanogl-post/effects/saturation'
// import Sharpen from 'nanogl-post/effects/sharpen'
// import Vignette from 'nanogl-post/effects/vignette'
// import Hejl from 'nanogl-post/effects/hejl'
// import Reinhard from 'nanogl-post/effects/reinhard'
// import Bloom from 'nanogl-post/effects/bloom'
// import Gamma from 'nanogl-post/effects/gamma_tb'
// import Dof from 'nanogl-post/effects/dof'
//import PostDepthDebug     from './post-depth-debug'
import GodsRay from '../glsl/godsray'

// import Quality  from '@/webgl/lib/quality'
 
import glmat, { vec2 } from 'gl-matrix'
import Scene  from '@/webgl/scene'

import { computed, watch } from 'vue'
import store from '@/store'


var vec3 = glmat.vec3;

export default class PostProcess {

  scene      : Scene
  post       : Post
  // chromashift: Chromashift
  // contrast   : Contrast
  // grain      : Grain
  godsRay    : GodsRay
  // sat        : Saturation
  // sharpen    : Sharpen
  // hejl       : Hejl
  // reinhard   : Reinhard
  // bloom      : Bloom
  // vignette   : Vignette
  // dof        : Dof

  _setup: number
  watchcurrqte


  constructor(scene: Scene) {


    this.scene = scene;

    this.post = new Post(scene.gl, false);
    this.post.enabled = true;//Quality.param('post');


    // this.chromashift = new Chromashift();

    // this.post.enabled = false
    // this.contrast = new Contrast(1.1, 1.0, .05);
    // this.grain = new Grain(.1, .7);
    
    const screenPos = vec2.create()
    vec2.set(screenPos, 0.333, 0.56)
    this.godsRay = new GodsRay(0.8, 0.022, 1.02, 0.9, 35, screenPos, 0.65)
    // this.sat = new Saturation(1.0);
    // this.sharpen = new Sharpen(.35, .25);
    // this.hejl = new Hejl(1);
    // this.reinhard = new Reinhard(1);
    // this.bloom = new Bloom([.1, .1, .1], .02);
    // this.vignette = new Vignette([0, 0, 0], .96, .34);
    // this.dof = new Dof(scene.camera);

    // this.dof.far = 200
    // this.dof.focusRange = 20
    // this.dof.near = 30
    // this.dof.focus = 80

    // this.lut      = new LUT([0,21,0,13,27,11,17,32,17,21,36,25,24,39,34,27,42,43,29,45,51,32,48,56,34,50,59,36,53,61,38,55,62,41,57,62,43,60,62,45,62,62,47,64,62,49,66,62,51,69,62,53,71,63,55,73,64,57,75,65,59,77,66,61,79,67,63,81,68,65,83,70,67,85,72,69,87,74,71,89,75,73,90,77,74,92,79,76,94,81,78,96,83,80,98,85,82,99,88,84,101,90,85,103,92,87,105,94,89,106,96,91,108,98,92,110,100,94,111,102,96,113,104,98,115,106,99,116,108,101,118,110,103,119,112,104,121,114,106,122,116,107,124,118,109,125,120,111,127,121,112,128,123,114,130,125,115,131,127,117,132,128,118,134,130,120,135,131,121,137,133,123,138,134,124,139,136,126,141,137,127,142,139,128,143,140,130,144,142,131,146,143,133,147,144,134,148,146,135,149,147,137,151,148,138,152,150,139,153,151,141,154,152,142,155,153,143,156,155,144,158,156,146,159,157,147,160,158,148,161,159,149,162,160,150,163,162,152,164,163,153,165,164,154,166,165,155,167,166,156,168,167,157,169,168,158,170,169,159,171,170,161,172,171,162,173,172,163,174,173,164,175,174,165,176,175,166,176,176,167,177,176,168,178,177,169,179,178,170,180,179,171,181,180,172,182,181,173,182,182,174,183,182,175,184,183,175,185,184,176,186,185,177,186,186,178,187,186,179,188,187,180,189,188,181,189,189,182,190,189,182,191,190,183,192,191,184,192,192,185,193,192,186,194,193,186,194,194,187,195,194,188,196,195,189,196,196,190,197,197,190,198,197,191,198,198,192,199,198,193,200,199,193,200,200,194,201,200,195,202,201,195,202,202,196,203,202,197,203,203,197,204,203,198,205,204,199,205,205,199,206,205,200,206,206,201,207,206,201,207,207,202,208,208,203,209,208,203,209,209,204,210,209,205,210,210,205,211,210,206,211,211,206,212,211,207,212,212,208,213,212,208,213,213,209,214,214,209,214,214,210,215,215,210,215,215,211,216,216,212,216,216,212,217,217,213,217,217,213,218,218,214,218,218,214,219,219,215,219,219,215,220,219,216,220,220,216,221,220,217,221,221,217,222,221,218,222,222,218,223,222,219,223,223,219,223,223,220,224,224,220,224,224,221,225,225,221,225,225,222,226,225,222,226,226,223,227,226,223,227,227,224,227,227,224,228,228,225,228,228,225,229,229,226,229,229,226,230,229,227,230,230,227,230,230,228,231,231,228,231,231,228,232,231,229,232,232,229,232,232,230,233,233,230,233,233,231,234,233,231,234,234,232,234,234,232,235,235,232,235,235,233,236,235,233,236,236,234,236,236,234,237,237,235,237,237,235,238,237,235,238,238,236,238,238,236,239,239,237,239,239,237,239,239,238,240,240,238,240,240,238,241,240,239,241,241,239,241,241,240,242,242,240,242,242,240,242,242,241,243,243,241,243,243,242,243,243,242,244,244,242,244,244,243,245,244,243,245,245,244,245,245,244,246,246,244,246,246,245,246,246,245,247,247,245,247,247,246,247,247,246,248,248,247,248,248,247,248,248,247,249,249,248,249,249,248,249,249,248,250,250,249,250,250,249,250,250,250,251,251,250,251,251,250,251,251,251,252,252,251,252,252,251,253,252,252,253,253,252,253,253,253,254,253,253,254,254,253,254,254,254,254,254,254,255,255,254,255,255,255,255,255,255,255,255,255,255,255])
    // this.reinhard = new Reinhard();


    this._setup = 0;


    // this.post.add(this.chromashift as any);

    const currqte = computed(() => store.getters['game/qte'])

    this.watchcurrqte = watch(currqte, (qte) => {
      if(qte === 2) this.godsRay.addMix = 0
      else this.godsRay.addMix = 0.3
    })

    this.post.add(this.godsRay)

    // this.post.add( this.dof );
    // this.post.add( this.sharpen );
    // this.post.add( this.bloom );
    // this.post.add( this.contrast );
    // this.post.add( this.grain );
    // this.post.add( this.sat );
    // this.post.add( this.hejl );
    // this.post.add( this.reinhard );
    // this.post.add( this.vignette );

    // this.post.add( this.lut );

    // this.post.add(new Gamma());

    // Quality.on( this, 'qualityChange' );


/////////////////
///////////////
//////////////

  }




  qualityChange() {
    console.log('quality change')
    // this.post.enabled = Quality.param( 'post' );


    // if( Quality.param('bloom') ){
    //   if( this.bloom.post === null )this.post.add( this.bloom, 1 );
    // }else{
    //   this.post.remove( this.bloom )
    // }

    // if( Quality.param('dof') ){
    //   // if( this.dof.post === null )this.post.add( this.dof, 1 );
    // }else{
    //   // this.post.remove( this.dof )
    // }
  }

  preRender() {
    // var cDist = vec3.distance( this.scene.camera.position, dofCenter );
    // this.dof.focus = cDist + .4;
    // this.dof.near = (cDist - this.dof.focusRange/2 ) - .1
    // this.dof.far  = cDist + 2
  }

  release() {
    this.watchcurrqte()
    this.godsRay.release()
  }



///////////////
//////////
//////////////////////////////////
/////////////////////////////////
/////////////////////////////////

///////////////////////////////////////////
//////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////
//////////////////////////////////////////////
///////////////////////////////////////////////////
////////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////////////
/////////
///////////////////////////////////////////////
///////////////////////////////////////////////////////
/////////
////////////////////////////////////////////
///////////////////////////////////////////////
//////////////////////////
//////////////
//////////////
////////////////
////////
//////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////
/////////
//////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////
/////////
//////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////
/////////


///////////////////////////////////
////////////////////////////////////////
///////////////////////////////////////////
//////////////////////////////////////
//////////////////////////////////////
///////////////////////////////////
///////////////////////////////////
//////////////////////////////////////////

////////////////////////////////////////
////////////////////////////////////////////////
///////////////////////////////////////////////
//////////////////////////////////////////////

////////////////////////////////
////////////////////////////////////////
///////////////////////////////////////////

/////////////////////////////////////
//////////////////////////////////////

//////////////////////////////////
//////////////////////////////////////////
/////////////////////////////////////////

///////////////////////////////////
//////////////////////////////////////////
/////////////////////////////////////////////

////////////////////////////////
///////////////////////////////////////
///////////////////////////

//////////////////////////////
//////////////////////////////////////////////////////////////////////////////////
///
////////////

}
